{
    "UserTour_Next": "Next",
    "UserTour_Cancel": "Show me later",
    "UserTour_Exit": "Disable tour",
    "NAME": "UserTour"
}